import { Container, Header } from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import {
  BankAccountForBankAccount,
  BankAccountsUpdateRequest,
} from "../../../features/api-interfaces";
import { BankAccountReference } from "./BankAccountReference";
import { BankAccountUpdate } from "./BankAccountUpdate";
import { IErrMsg, LABELS } from "../constants";

interface IBankAccount {
  bankAccount?: BankAccountForBankAccount;
  isUpdate?: boolean;
  editingRequest?: BankAccountsUpdateRequest;
  setEditingRequest?: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
  errMsg?: IErrMsg;
  setErrMsg?: Dispatch<SetStateAction<IErrMsg>>;
}

/**
 * 入金口座情報照会・更新 口座情報
 */
export const BankAccount = (props: IBankAccount) => {
  const {
    bankAccount,
    isUpdate = false,
    editingRequest,
    setEditingRequest,
    errMsg,
    setErrMsg,
  } = props;

  return (
    <Container
      header={<Header variant={"h2"}>{LABELS.BANK_ACCOUNT_TITLE}</Header>}
    >
      {isUpdate ? (
        <BankAccountUpdate
          editingRequest={editingRequest}
          setEditingRequest={setEditingRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
      ) : (
        <BankAccountReference bankAccount={bankAccount} />
      )}
    </Container>
  );
};
